import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export function getRules() {
   const { t } = useI18n();

   return yup.object({
      video_id: yup
         .string()
         .trim()
         .min(1, t('live-editor.content-blocks.errors.required'))
         .required(t('live-editor.content-blocks.errors.required')),
   });
}
